<section class="section">
  <div class="section-content">
    <div class="section-main">
      <div class="section-content-container section-3-content-container">
        <text-header i18n>O czym możemy porozmawiać?</text-header>
        <text [bold]="true" i18n>
          O czym tylko zechcesz i o tym czego potrzebujesz. Pamiętaj, że jesteśmy tu dla Ciebie.
        </text>
        <text i18n>
          Jeśli zmagasz się z depresją, brakiem akceptacji siebie, nie możesz odnaleźć się w nowym
          środowisku, czujesz, że żyjesz nie w swoim ciele - jesteśmy tu dla Ciebie.
        </text>
        <text i18n>
          Jeśli nie radzisz sobie ze stresem, przerastają Cię obowiązki zawodowe lub czujesz
          wypalenie zawodowe - jesteśmy tu dla Ciebie.
        </text>
        <text i18n> Jeśli czujesz lęk i niepokój - jesteśmy dla Ciebie </text>
        <text i18n>
          Problemy w związku lub w łóżku? To żaden wstyd. Dla nas nie ma tematów tabu.
        </text>
        <text i18n>
          Ps. Na tej krótkiej liście nie ma tego, czego szukasz? Możesz mieć pewność, że wspólnie
          damy sobie ze wszystkim radę.
        </text>
      </div>
    </div>
  </div>
</section>
